import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";

//Components
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import Summary from 'Components/Summary';
import { Divider } from "@mui/material";

//Actions
import { dataDetailsCloseModal } from 'Redux/actions';


const DataDetails = () => {
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const { openModal, data } = useSelector(state => state.dataDetailsRedux);
    const [changes, setChanges] = useState([])
    const closeModal = () => {
        dispatch(dataDetailsCloseModal());
        setChanges([]);
    }

    useEffect(() => {
        if (data) {
            try {
                let currentChange = JSON.parse(data);
                let validateArray = Array.isArray(currentChange);
                if (validateArray) setChanges(currentChange)
                else setChanges([currentChange])
            } catch (error) { }
        }
    }, [data])

    const isArrayNumbers = (arr) => {
        return arr.length ? arr.every(item => typeof item === 'number') : false
    }
    
    return (
        <Modal
            open={openModal}
            title={messages['data_details_title']}
            loading={false}
            position="right"
            size="small"
            handleClose={closeModal}
        >
            <ModalBody>
                <div style={{ padding: '0 10px', marginBottom: 10 }}>
                    {
                        changes && changes.length > 0 ? (
                            <>
                                {
                                    changes.map((item, index) => {
                                        let data = isArrayNumbers(changes) ? { data: item } : item
                                        return (
                                            <div key={index}>
                                                {
                                                    changes.length > 1 &&
                                                    <>
                                                        <p style={{ marginBottom: 5, fontWeight: 500 }}>{`${messages['data_details_title']} ${index + 1}`}</p>
                                                        <Divider style={{ backgroundColor: '#999999', marginBottom: 10 }} />
                                                    </>
                                                }
                                                <Summary data={data} columns={3} addDash />
                                            </div>
                                        )
                                    })
                                }
                            </>
                        ) : <div><span>{messages['new_migration_no_data_available']}</span></div>
                    }
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-dark-blue"
                    onClick={() => closeModal()}
                >
                    {messages['close']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default DataDetails;